var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          staticStyle: { "max-width": "500px !important", top: "100px" },
          attrs: { id: "wishList-modal", "hide-footer": "", "hide-header": "" },
        },
        [
          _c(
            "b-tabs",
            { attrs: { "content-class": "mt-3" } },
            [
              _c(
                "b-tab",
                { attrs: { title: "auf Merkliste setzen", active: "" } },
                [
                  _c("add-to-wish-list", {
                    attrs: { wishListEan: _vm.wishListEan },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "neue Merkliste anlegen" } },
                [
                  _c("create-wish-list", {
                    attrs: {
                      modalName: _vm.modalName,
                      wishListEan: _vm.wishListEan,
                      Action: _vm.WishListAction,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }